module.exports = __webpack_public_path__ + "img/PPT.0f91e1e9.svg";